var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.transitionComponent,{tag:"component"},[_c('router-view',{key:_setup.path})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }